export const NotificationType = Object.freeze({
  ActionRequired: 1,
  General: 2
});
